var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.45067 14.1035L11.4033 20.6348C11.596 20.8158 11.6923 20.9063 11.7997 20.9465C11.9289 20.9948 12.0711 20.9948 12.2003 20.9465C12.3077 20.9063 12.404 20.8158 12.5967 20.6348L19.5493 14.1035C21.5055 12.2659 21.743 9.24191 20.0978 7.12138L19.7885 6.72265C17.8203 4.18589 13.8696 4.61133 12.4867 7.50896C12.2913 7.91827 11.7087 7.91827 11.5133 7.50896C10.1304 4.61133 6.17972 4.1859 4.21154 6.72266L3.90219 7.12138C2.25695 9.24191 2.4945 12.2659 4.45067 14.1035Z",
    stroke: "#ABAFB9",
    strokeWidth: 1.71429
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.484e9cdd7ac38e0a554dcfba15c4e973.svg";
export { ForwardRef as ReactComponent };